/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskExposureSlice = {
  /**
   * Canonical risk category key.
   */
  category: string;
  /**
   * Deduplicated finding count for this category in the window.
   */
  findings: number;
  /**
   * Fraction of the window's findings in this category (0-1).
   */
  share: number;
};

/** @internal */
export const RiskExposureSlice$inboundSchema: z.ZodMiniType<
  RiskExposureSlice,
  unknown
> = z.object({
  category: z.string(),
  findings: z.int(),
  share: z.number(),
});

export function riskExposureSliceFromJSON(
  jsonString: string,
): SafeParseResult<RiskExposureSlice, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskExposureSlice$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskExposureSlice' from JSON`,
  );
}
